import type { MascotState, Step } from "../contract"
import { Beam, beamStateFor } from "../ds"

export interface TimedStep extends Step { t: number }

/** One live event row: "{t}s", a status dot, the label (and detail). */
export function EventRow({ step }: { step: TimedStep }) {
  return (
    <li className={`e ${step.status}`}>
      <span className="ets">{step.t.toFixed(1)}s</span>
      <span className="dt" aria-hidden="true" />
      <span>
        {step.label}
        {step.detail ? ` · ${step.detail}` : ""}
        {step.status === "run" ? <span className="vh"> (in progress)</span> : null}
      </span>
    </li>
  )
}

/** Working card: the beam at work and the live step list, announced politely. */
export function Loader({ steps, mascot, id, label = "NIRA", title = "Working on it", note }: {
  steps: TimedStep[]
  mascot: MascotState
  id: string
  label?: string
  title?: string
  /** One quiet line under the steps (Nira: how long it usually takes). */
  note?: string
}) {
  return (
    <article className="card loader nira-run nira-run--search" id={id}>
      <div className="chead">
        <Beam state={beamStateFor(mascot)} size="hero" />
        <div>
          <p className="ov">{label} · WORKING</p>
          <h3>{title}</h3>
        </div>
      </div>
      <ol className="ev" aria-live="polite">
        {steps.map((s) => <EventRow key={s.id} step={s} />)}
      </ol>
      {note ? <p className="lnote">{note}</p> : null}
    </article>
  )
}
